// semeia-disable-reexport

export function practiceLocationIndex(selectedPracticeLocation, availablePracticeLocations) {
  return availablePracticeLocations?.findIndex(location => location.structureName?.toUpperCase() == selectedPracticeLocation?.toUpperCase());
}